import React from 'react';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CalendarReportFilter = (props) => {
  let picker = null,
    openedByButton = false,
    toggleDateTime = () => {
      if (picker.state.open || openedByButton) {
        picker.closeCalendar();
        openedByButton = false;
      } else {
        openedByButton = true;
        picker.openCalendar();
      }
    },
    isValidDate =
      typeof props.isValidDate === 'function' ? props.isValidDate : () => true;

  return (
    <div
      className={`datetime-wrap ${props.className || ''}`}
      style={props.style || {}}
    >
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id="datetime-tooltip">{props.title}</Tooltip>}
      >
        <i className="fa fa-calendar datetime-icon" onClick={toggleDateTime} />
      </OverlayTrigger>
      <Datetime
        onChange={props.onChange}
        ref={(e) => (picker = e)}
        isValidDate={isValidDate}
        utc={false}
        defaultValue={props.defaultValue}
        dateFormat="MM/YYYY"
        timeFormat={false}
        closeOnSelect={true}
        inputProps={{
          className: 'form-control form-control-sm',
          style: { width: '100%', outline: 'none !important' },
        }}
      />
    </div>
  );
};

CalendarReportFilter.propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.any,
  style: PropTypes.object,
  title: PropTypes.string,

  isValidDate: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

export default CalendarReportFilter;
